<template>
	<v-row class="plan-row px-2 my-2" align="center"
				 :class="{ active: canSelect && activePlanId == plan.id }"
				 @click="$emit('select',plan)">
		<v-img v-if="canSelect && activePlanId == plan.id" src="/assets/v-icon.png" class="active-v-icon"></v-img>
		<v-col cols="4" class="pa-2">
			<v-img :src="image" width="75" height="75"></v-img>
		</v-col>
		<v-col cols="8" align="start">
			<v-row class="font-weight-bold">
				<span class="title-size">{{ plan.description }}</span>
				<span v-if="plan.additional_text"> - {{ plan.additional_text }}</span>
			</v-row>
			<v-row v-if="!plan.custom_price" class="blue-color title-size">
				<div class="font-weight-bold">{{ priceStr.whole }}</div>
				<span :class="priceStr.whole.length < 2
								? 'plan-component__card--price--decimals--shekel'
								: 'plan-component__card--price--decimals--shekel-high'">
						<span v-if="plan.currency === 'USD'">$</span>
						<span v-else>&#8362;</span>
					</span>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "SinglePlanComponent",
	props: {
		plan: Object, choosePlan: Function, activePlanId: [Number, String], customPrice: Number,
		image: String, canSelect: Boolean
	},
	computed: {
		clientCustomPrice: {
			get() {
				return this.customPrice;
			},
			set(custom) {
				this.$emit("custom", { plan: this.plan.id, custom });
			}
		},
		usageStr() {
			const plan = this.plan;
			if (plan.type === 1) {
				if (plan.amount === 1) return "שימוש אחד במשחק";
				else return `${plan.amount} שימושים במשחק`;
			} else if (plan.type === 2) {
				if (plan.amount === 1) return "יום שימוש במשחק";
				else return `${plan.amount} ימים של שימוש במשחק`;
			} else {
				if (plan.amount === 1) return "שעה של שימוש במשחק";
				else return `${plan.amount} שעות של שימוש במשחק`;
			}
		},
		priceStr() {
			const price = this.plan.price.toFixed(2);
			const whole = parseInt(price);
			const decimals = price - Math.floor(price);
			return { whole, decimals };
		},
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../sass/variables.scss";

.plan-row {
	background-color: $main-bg-color;
	border: 1px solid $blue-color;
	border-radius: 10px;
	cursor: pointer;
	position: relative;
}

.active {
	border: 4px solid $blue-color;
}

.active-v-icon {
	position: absolute;
	right: -10px; /* Adjust this value based on how far outside you want the icon */
	top: 50%;
	transform: translateY(-50%);
	width: 20px; /* Adjust size as needed */
	height: 20px; /* Adjust size as needed */
}

.blue-color {
	color: $blue-color;
}

</style>
